import { useEffect } from "react";
import { attachSentryContext } from "../utils/attach-sentry-context";
import { Session } from "next-auth";
export default function useSentryLogging(session?: Session | undefined) {
  useEffect(() => {
    if (session) {
      attachSentryContext(session);
    }
  }, [session]);
}